import { ActionType } from "../actions/actionTypes";

type CurrentApplicationState = {
  metadata?: { [key: string]: any };
  application: Application;
  basicPolicy?: BasicPolicyDTO;
  productSelectionValues?: ProductSelectionValues;
  submitting: boolean;
};

const INITIAL_STATE = {
  application: {},
  submitting: false
};

export default (
  state: CurrentApplicationState = INITIAL_STATE,
  action: ActionType
): CurrentApplicationState => {
  switch (action.type) {
    case "EDIT_APPLICATION": {
      return { ...state, ...action.payload, submitting: false };
    }
    case "CANCEL_APPLICATION": {
      return INITIAL_STATE;
    }
    case "UPDATE_APPLICATION_REQUEST":
      return { ...state, submitting: true };
    case "CREATE_APPLICATION_SUCCESS":
    case "UPDATE_APPLICATION_SUCCESS": {
      return { ...state, ...action.payload, submitting: false };
    }
    case "CREATE_APPLICATION_FAILURE":
    case "UPDATE_APPLICATION_FAILURE":
    case "CONVERT_TO_QUOTE_FAILURE": {
      // TODO: Handle Error
      return { ...state, submitting: false };
    }
    case "CONVERT_TO_QUOTE_SUCCESS": {
      return { ...state, ...action.payload, submitting: false };
    }
    default:
      return state;
  }
};
